document.addEventListener("DOMContentLoaded", function () {
    fix_nav();
    nav_subMenu();
    highlight_nav();
    // leap_nav();
    xpand_icon();
    close_banner();
})

function close_banner() {
    const acceptButton = document.getElementById('accept-cookies');
    const rejectButton = document.getElementById('decline-cookies');
    const consentBanner = document.getElementById('banner-cookies');

    if (!acceptButton || !consentBanner) return;

    // Función de utilidad para leer una cookie (necesaria para el CSRF token)
    function getCookie(name) {
        let cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }

    const csrftoken = getCookie('csrftoken');

    // if (!getCookie('cookie_consent')) {
    //     consentBanner.classList.remove('hide');
    // }

    if (consentBanner) {
        // Si la cookie de consentimiento ya existe, ocultamos el banner inmediatamente
        if (getCookie('cookie_consent')) {
            consentBanner.classList.add('hide');
        } else {
            consentBanner.classList.remove('hide');
        }
    }

    function sendConsent(status) {
        const url = COOKIE_CONSENT_URL;

        if (!csrftoken) {
            console.error("CSRF Token no encontrado. No se puede enviar el consentimiento.");
            return;
        }

        fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-CSRFToken': csrftoken
                },
                body: `status=${status}`
            })
            .then(response => {
                if (response.ok) {
                    consentBanner.classList.add('hide');
                } else if (response.status === 403) {
                    console.error("Error 403: Petición rechazada por CSRF.");
                } else {
                    console.error(`Error al procesar la petición: ${response.status}`);
                }
            })
            .catch(error => {
                console.error('Error al enviar el consentimiento:', error);
            });
    }

    // 3. Listeners de los botones
    if (acceptButton) {
        acceptButton.addEventListener('click', () => sendConsent('accepted'));
    }
    if (rejectButton) {
        rejectButton.addEventListener('click', () => sendConsent('rejected'));
    }
}

function xpand_icon() {
    const hamb = document.querySelector('div.header-hamb');
    const cont = document.querySelector('div.header-cont');
    const hide = document.querySelector('#hide_menu');
    if (!hamb || !cont || !hide) return;

    hamb.addEventListener('click', () => {
        // ocultar el botón hamburguesa
        hamb.style.display = 'none';
        // mostrar el contenedor de navegación (ajusta display si hace falta)
        cont.style.display = 'flex';
        cont.style.flexDirection = "column";
    });

    hide.addEventListener('click', () => {
        hamb.style.display = 'flex';
        cont.style.display = 'none';
    });
}

function fix_nav() {
    const header = document.querySelector(".header");
    const section = document.querySelector(".special");

    window.addEventListener("scroll", function () {
        if (section.getBoundingClientRect().top < 150) {
            header.classList.add("fixed");
        } else {
            header.classList.remove("fixed");
        }

    })
}

function highlight_nav() {
    const nav_a = document.querySelectorAll(".main-nav a");
    const sections = document.querySelectorAll("section");
    const spaceBefore = 400;

    window.addEventListener("scroll", function () {
        // console.log(this.window.scrollY);

        // primero busco la seccion actual
        let acutal = "";
        sections.forEach(section => {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;


            // console.log(sectionTop);
            // console.log((sectionTop - sectionHeight) / 3);

            // if (this.window.scrollY >= (sectionTop - sectionHeight) / 3) {
            if (this.window.scrollY >= (sectionTop - spaceBefore)) {
                // console.log(section.id);
                actual = section.id
            }
        })


        // resalto la navegacion por la seccion donde esta
        nav_a.forEach(link => {
            link.classList.remove("active");
            if (link.id === "A" + actual) {
                link.classList.add("active");
            }
        })
    })
}

function nav_subMenu() {
    const dropdown = document.querySelector('.dropdown-container');
    const content = document.querySelector('.dropdown-content');
    let timeoutId; // Variable para almacenar el ID del temporizador

    // Función de retardo para abrir (mouseover)
    dropdown.addEventListener('mouseenter', () => {
        // Limpiamos cualquier temporizador de cierre pendiente
        clearTimeout(timeoutId);

        // Añadimos la clase directamente, pero el efecto lo maneja CSS
        // Si CSS no fuera suficiente, podríamos usar setTimeout aquí:
        // setTimeout(() => content.classList.add('open'), 200); 
        // Pero con la implementación CSS actual, el hover es más rápido y limpio.
    });

    // Función de retardo para cerrar (mouseleave)
    dropdown.addEventListener('mouseleave', () => {
        // Establecemos un pequeño retardo de 200ms antes de cerrar
        timeoutId = setTimeout(() => {
            // Quitamos la clase que hace que el CSS se active
            // content.classList.remove('open');
        }, 200);
    });
}

// function leap_nav() {
//     const nav_a = document.querySelectorAll(".main-nav a");

//     nav_a.forEach( link => {
//         link.addEventListener("click", e => {
//             e.preventDefault();

//             const section2Scroll = link.getAttribute("href");
//             //seleccionamos la seccion clickeada
//             const section = document.querySelector(section2Scroll);

//             section.scrollIntoView({behavior: "smooth"})
//             // console.log();
//         })
//     })
// }